var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisa(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 48,
    height: 32,
    rx: 4,
    fill: "#121318"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.35 25.67c.006-1.525-1.251-2.183-2.227-2.694C27.505 22.652 27 22.388 27 22c0-.33.32-.68 1-.77a4.48 4.48 0 012.36.41l.42-2a6.438 6.438 0 00-2.24-.41c-2.36 0-4 1.26-4 3.06 0 1.33 1.19 2.07 2.09 2.51.9.44 1.25.75 1.24 1.15 0 .62-.74.9-1.43.91a5 5 0 01-2.44-.6l-.43 2c.848.33 1.75.497 2.66.49 2.51 0 4.16-1.24 4.17-3.16l-.05.08zm-6.49-6.28l-2 9.25h-2.4l2-9.25h2.4zm10.06 6l1.26-3.47.73 3.47h-1.99zm4.89 3.28h-2.22l-.29-1.38h-3.01l-.49 1.38h-2.52l3.59-8.57a1.09 1.09 0 011-.68h2l1.94 9.25zm-22.2-.06l3.88-9.25h-2.6l-2.49 6.29-1-5.35a1.12 1.12 0 00-1.11-.94H9.22l-.06.27c.816.16 1.61.422 2.36.78a1 1 0 01.57.81L14 28.61h2.61z",
    fill: "#fff"
  })));
}

export default SvgVisa;